export default {
  responsible: 'Responsible',
  reviewModalTitle: 'Project Review',
  evaluateProject: 'Evaluate Project',
  yourRecruiter: 'Your Recruiter',
  review: 'Review',
  myReview: 'My Review',
  comment: 'Comment',
  frelancerReviewed: 'Freelancer Reviewed',
  recruiterAndAlliancesReviewed: 'Recruiter and Alliances Reviewed',
  recruiterAndAlliancesNotified: 'The Recruiter and your Alliances will be notified.',
  commentPlaceholder: 'Leave a comment...',
  reviewAlreadySubmitted: 'You have already reviewed {{name}} in this project.',
  rateRequired: 'Please provide a rating.',
  bidder: 'Bidder',
  successfulRating: 'Your evaluation of {{name}} has been successfully saved',
  evaluation: 'review',
  from: 'from',
  noReviews: 'No reviews found',
  loadMoreReviews: 'Load more reviews',
  review_counts_one: '{{count}} review',
  review_counts_plural: '{{count}} reviews',
  cancel_review: 'Cancel Review',
  cancel_review_hint:
    'Are you sure you want to cancel this review? You can always reactivate it later.',
  cancel_and_confirm: 'Cancel and Confirm',
  approve_review: 'Approve Review',
  has_reviewed: 'has reviewed',
  validate_review: 'Validate review',
  validate_review_hint: 'Are you sure you want to validate this review? It will become public.',
  update_review_status: 'Update review status',
};
